var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.243 6.04247L9.49 0.498467C9.64542 0.405216 9.82325 0.355957 10.0045 0.355957C10.1857 0.355957 10.3636 0.405216 10.519 0.498467L19.757 6.04347C19.8311 6.08788 19.8925 6.15075 19.9351 6.22593C19.9776 6.30112 20 6.38606 20 6.47247V19.1885C20 19.4537 19.8946 19.708 19.7071 19.8956C19.5196 20.0831 19.2652 20.1885 19 20.1885H1C0.734784 20.1885 0.48043 20.0831 0.292893 19.8956C0.105357 19.708 1.10073e-08 19.4537 1.10073e-08 19.1885V6.47147C-1.81179e-05 6.38506 0.0223578 6.30012 0.0649455 6.22493C0.107533 6.14975 0.168879 6.08688 0.243 6.04247ZM2 7.32147V18.1885H18V7.32047L10.004 2.52047L2 7.32047V7.32147ZM10.06 12.8865L15.356 8.42347L16.644 9.95347L10.074 15.4905L3.364 9.96047L4.636 8.41647L10.06 12.8865Z",
    fill: "#0A93D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailto);
export default __webpack_public_path__ + "static/media/mailto.5ac80ae5f524fa67f9531209871b6126.svg";
export { ForwardRef as ReactComponent };